import { Brush, Close, Settings, Visibility } from '@mui/icons-material';
import { AppBar, IconButton, Tab, Tabs, Toolbar } from '@mui/material';
import { useTranslation } from 'next-i18next';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
  onClick?: () => void;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, onClick, ...other } = props;

  return (
    <div onClick={onClick} role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
      {value === index && <div className="settings-wrapper">{children}</div>}
    </div>
  );
};

interface SidebarToolbarInterface {
  onClose?: () => void;
  onChange?: (event: React.ChangeEvent<{}>, newValue: number) => void;
  name?: string;
  value?: number;
}

const SidebarToolbar = ({ name, value, onChange, onClose }: SidebarToolbarInterface) => {
  const { t } = useTranslation('pagebuilder');

  function a11yProps(index: any) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  return (
    <AppBar style={{ background: '#001c38' }} position="sticky">
      <Toolbar>
        <p className="justify-start text-xl grow text-slate-50">{t('pagebuilder:edit-component', { name })}</p>
        <IconButton className="justify-end" style={{ outline: 'none' }} onClick={onClose} size="large">
          <Close htmlColor="#ffffff" />
        </IconButton>
      </Toolbar>
      <Tabs
        value={value}
        onChange={onChange}
        textColor="primary"
        indicatorColor="primary"
        variant="fullWidth"
        aria-label="full width tabs example"
        style={{ background: 'white' }}>
        <Tab
          style={{ outline: 'none' }}
          label={
            <>
              <Settings /> {t('pagebuilder:settings')}
            </>
          }
          {...a11yProps(0)}
        />
        <Tab
          style={{ outline: 'none' }}
          label={
            <>
              <Brush />
              {t('pagebuilder:styling')}
            </>
          }
          {...a11yProps(1)}
        />
        <Tab
          style={{ outline: 'none' }}
          label={
            <>
              <Visibility />
              {t('pagebuilder:visibility')}
            </>
          }
          {...a11yProps(1)}
        />
      </Tabs>
    </AppBar>
  );
};

export default SidebarToolbar;
